import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class MessageThreadRequestHelpArgs {
  @Field(t => Int)
  threadId!: number

  @Field(t => Int, { nullable: true })
  arcTeamId!: number

  @Field(t => Int, { nullable: true })
  penNameId!: number
}
